import { CourseDataFilters } from '../types/filtered-data';
import { QueryParams } from '../types/common';

/**
 * Builds Series-specific filters from base filters
 */
export function buildSeriesFilter(
  filters: Partial<CourseDataFilters>,
): QueryParams<any, any>['filters'] {
  const filter: QueryParams<any, any>['filters'] = {};

  if (filters.skillLevels && filters.skillLevels.length > 0) {
    filter.skillLevel = { name: { $in: [...filters.skillLevels, 'Per tutti'] } };
  }

  if (filters.genres && filters.genres.length > 0) {
    filter.musicalGenres = { name: { $in: filters.genres } };
  }

  if (filters.instruments && filters.instruments.length > 0) {
    filter.lessons = { instrument: { instrumentName: { $in: filters.instruments } } };
  }

  if (filters.topics && filters.topics.length > 0) {
    filter.topics = { name: { $in: filters.topics } };
  }

  return filter;
}

/**
 * Builds Learning Path-specific filters from base filters
 */
export function buildLearningPathsFilter(
  filters: Partial<CourseDataFilters>,
): QueryParams<any, any>['filters'] {
  const filter: QueryParams<any, any>['filters'] = {};

  if (filters.instruments && filters.instruments.length > 0) {
    filter.lessons = { instrument: { instrumentName: { $in: filters.instruments } } };
  }

  if (filters.skillLevels && filters.skillLevels.length > 0) {
    filter.skillLevel = { name: { $in: [...filters.skillLevels, 'Per tutti'] } };
  }

  if (filters.genres && filters.genres.length > 0) {
    filter.musicalGenres = { name: { $in: filters.genres } };
  }

  if (filters.topics && filters.topics.length > 0) {
    filter.topics = { name: { $in: filters.topics } };
  }

  return filter;
}

/**
 * Builds Masterclass-specific filters from base filters
 */
export function buildMasterclassesFilter(
  filters: Partial<CourseDataFilters>,
): QueryParams<any, any>['filters'] {
  const filter: QueryParams<any, any>['filters'] = {};

  if (filters.skillLevels && filters.skillLevels.length > 0) {
    filter.skillLevel = { name: { $in: [...filters.skillLevels, 'Per tutti'] } };
  }

  if (filters.genres && filters.genres.length > 0) {
    filter.musicalGenres = { name: { $in: filters.genres } };
  }

  if (filters.instruments && filters.instruments.length > 0) {
    filter.instrument = { instrumentName: { $in: filters.instruments } };
  }

  if (filters.topics && filters.topics.length > 0) {
    filter.topics = { name: { $in: filters.topics } };
  }

  return filter;
}

/**
 * Creates complete filter data for API requests
 */
export function buildFilteredDataFilters(
  filters: Partial<CourseDataFilters>,
  page: { page: number; pageSize: number },
  additionalParams: Record<string, any> = {},
) {
  return {
    page,
    seriesFilters: buildSeriesFilter(filters),
    learningPathFilter: buildLearningPathsFilter(filters),
    masterclassFilter: buildMasterclassesFilter(filters),
    courseType: filters.types || [],
    ...additionalParams,
  };
}
